import React, { useEffect } from "react";
import MainPageDialog from "../../components/mainPageDialog";
import DateIcon from "../../assests/images/date.png";
import { useGetTrackerHistoryQuery } from "../../redux/service/trackers_service";
import moment from "moment";
import FullScreenLoader from "../../components/FullScreenLoader";
const TrackerHistory = ({ trackerId = 0, title, clearSelectedCard }) => {
  const {
    data,
    isFetching: isLoading,
    refetch,
  } = useGetTrackerHistoryQuery({
    tracker_id: trackerId,
  });

  //refetch data
  useEffect(() => {
    refetch();
  }, []);

  const cancelHandler = () => {
    clearSelectedCard();
  };

  const getFooterList = [
    {
      title: "Close",
      action: cancelHandler,
      type: "cancel",
    },
  ];

  return (
    <div className={`${isLoading && "animate-pulse"}`}>
    
      <MainPageDialog
        title={title}
        modalSize="md"
        onCancelHandler={cancelHandler}
        footer={true}
        maxHeight={true}
        footerList={getFooterList}>
          

          {isLoading &&  <FullScreenLoader/>}
        <div className="px-3 py-5  text-left text-sm text-gray-900">
          {data?.map((item) => (
            <>
              {item?.value?.map((value) => {
                return (
                  <>
                    <div className="flex justify-between p-2 text-large mt-2">
                      <div>
                        <p>
                          <span>
                            {" "}
                            {value?.value}{" "}
                            <span className="font-bold">{value?.unit}</span>
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-x-1 mb-1">
                      <img src={DateIcon} alt="date" className="w-4 h-4" />
                      <p>{moment(value?.datetime).format("MM/DD/YYYY h:mm a")}</p>
                    </div>
                    <div class="flex-grow border-t border-gray-400"></div>
                  </>
                );
              })}
            </>
          ))}
          {data?.length === 0 && <p>No data found</p>}
        </div>
      </MainPageDialog>
    </div>
  );
};

export default TrackerHistory;
